import { ModuleConfig, ModuleFields } from "~/Utils/drilldownData";
import { fetchDepartment } from "./CPOsOffice/FetchDepartment";

export const getContactDirectoryDrillDownData: { [key in ModuleConfig]: ModuleFields[] } = {
  operation: [
    {
      fieldName: "Name (EN)",
      fieldValue: "field_profile_name_en",
      className: "col-span-6",
      type: "text",
      name: "field_profile_name_en",
      formType: "input",
      label: "Name (EN)",
      placeholder: "Enter Name (EN)",
      validation: { required: "Name (EN) is required" },
    },
    {
        fieldName: "Name (MS)",
        fieldValue: "field_profile_name_ms",
        className: "col-span-6",
        type: "text",
        name: "field_profile_name_ms",
        formType: "input",
        label: "Name (MS)",
        placeholder: "Enter Name (MS)",
        // validation: { required: "Name (MS) is required" },
    },
    {
        fieldName: "Name (ZH)",
        fieldValue: "field_profile_name_zh",
        className: "col-span-6",
        type: "text",
        name: "field_profile_name_zh",
        formType: "input",
        label: "Name (ZH)",
        placeholder: "Enter Name (ZH)",
        // validation: { required: "Name (ZH) is required" },
    },
    {
        fieldName: "Designation (EN)",
        fieldValue: "field_profile_designation_en",
        className: "col-span-6",
        type: "text",
        name: "field_profile_designation_en",
        formType: "input",
        label: "Designation (EN)",
        placeholder: "Enter Designation (EN)",
        validation: { required: "Designation (EN) is required" },
    },
    {
        fieldName: "Designation (MS)",
        fieldValue: "field_profile_designation_ms",
        className: "col-span-6",
        type: "text",
        name: "field_profile_designation_ms",
        formType: "input",
        label: "Designation (MS)",
        placeholder: "Enter Designation (MS)",
        // validation: { required: "Designation (MS) is required" },
    },
    {
        fieldName: "Designation (ZH)",
        fieldValue: "field_profile_designation_zh",
        className: "col-span-6",
        type: "text",
        name: "field_profile_designation_zh",
        formType: "input",
        label: "Designation (ZH)",
        placeholder: "Enter Designation (ZH)",
        // validation: { required: "Designation (ZH) is required" },
    },
    {
        fieldName: "Unit (EN)",
        fieldValue: "field_unit_subcategory_en",
        className: "col-span-6",
        type: "text",
        name: "field_unit_subcategory_en",
        formType: "input",
        label: "Unit (EN)",
        placeholder: "Enter Unit (EN)",
        validation: { required: "Unit (EN) is required" },
    },
    {
        fieldName: "Unit (MS)",
        fieldValue: "field_unit_subcategory_ms",
        className: "col-span-6",
        type: "text",
        name: "field_unit_subcategory_ms",
        formType: "input",
        label: "Unit (MS)",
        placeholder: "Enter Unit (MS)",
        // validation: { required: "Unit (MS) is required" },
    },
    {
        fieldName: "Unit (ZH)",
        fieldValue: "field_unit_subcategory_zh",
        className: "col-span-6",
        type: "text",
        name: "field_unit_subcategory_zh",
        formType: "input",
        label: "Unit (ZH)",
        placeholder: "Enter Unit (ZH)",
        // validation: { required: "Unit (ZH) is required" },
    },
    {
      fieldName: "Email",
      fieldValue: "field_email_id",
      className: "col-span-6",
      type: "text",
      name: "field_email_id",
      formType: "input",
      label: "Email",
      placeholder: "Enter Email",
      validation: { required: "Email is required" },
    },
    {
        fieldName: "Phone Number",
        fieldValue: "field_phone_number",
        className: "col-span-6",
        type: "text",
        name: "field_phone_number",
        formType: "number",
        label: "Phone Number",
        placeholder: "Enter Phone Number",
        validation: { required: "Phone Number is required" },
    },
    {
        fieldName: "Published",
        fieldValue: "field_contact_profile_published",
        className: "col-span-12",
        type: "checkbox",
        name: "field_contact_profile_published",
        formType: "checkbox",
        label: "Published",
        placeholder: "Enter Published",
        // validation: { required: "Published is required" },
    },
  ],
  excellence: [
    {
      fieldName: "Name (EN)",
      fieldValue: "field_profile_name_en",
      className: "col-span-6",
      type: "text",
      name: "field_profile_name_en",
      formType: "input",
      label: "Name (EN)",
      placeholder: "Enter Name (EN)",
      validation: { required: "Name (EN) is required" },
    },
    {
        fieldName: "Name (MS)",
        fieldValue: "field_profile_name_ms",
        className: "col-span-6",
        type: "text",
        name: "field_profile_name_ms",
        formType: "input",
        label: "Name (MS)",
        placeholder: "Enter Name (MS)",
        // validation: { required: "Name (MS) is required" },
    },
    {
        fieldName: "Name (ZH)",
        fieldValue: "field_profile_name_zh",
        className: "col-span-6",
        type: "text",
        name: "field_profile_name_zh",
        formType: "input",
        label: "Name (ZH)",
        placeholder: "Enter Name (ZH)",
        // validation: { required: "Name (ZH) is required" },
    },
    {
        fieldName: "Designation (EN)",
        fieldValue: "field_profile_designation_en",
        className: "col-span-6",
        type: "text",
        name: "field_profile_designation_en",
        formType: "input",
        label: "Designation (EN)",
        placeholder: "Enter Designation (EN)",
        validation: { required: "Designation (EN) is required" },
    },
    {
        fieldName: "Designation (MS)",
        fieldValue: "field_profile_designation_ms",
        className: "col-span-6",
        type: "text",
        name: "field_profile_designation_ms",
        formType: "input",
        label: "Designation (MS)",
        placeholder: "Enter Designation (MS)",
        // validation: { required: "Designation (MS) is required" },
    },
    {
        fieldName: "Designation (ZH)",
        fieldValue: "field_profile_designation_zh",
        className: "col-span-6",
        type: "text",
        name: "field_profile_designation_zh",
        formType: "input",
        label: "Designation (ZH)",
        placeholder: "Enter Designation (ZH)",
        // validation: { required: "Designation (ZH) is required" },
    },
    {
        fieldName: "Unit (EN)",
        fieldValue: "field_unit_subcategory_en",
        className: "col-span-6",
        type: "text",
        name: "field_unit_subcategory_en",
        formType: "input",
        label: "Unit (EN)",
        placeholder: "Enter Unit (EN)",
        validation: { required: "Unit (EN) is required" },
    },
    {
        fieldName: "Unit (MS)",
        fieldValue: "field_unit_subcategory_ms",
        className: "col-span-6",
        type: "text",
        name: "field_unit_subcategory_ms",
        formType: "input",
        label: "Unit (MS)",
        placeholder: "Enter Unit (MS)",
        // validation: { required: "Unit (MS) is required" },
    },
    {
        fieldName: "Unit (ZH)",
        fieldValue: "field_unit_subcategory_zh",
        className: "col-span-6",
        type: "text",
        name: "field_unit_subcategory_zh",
        formType: "input",
        label: "Unit (ZH)",
        placeholder: "Enter Unit (ZH)",
        // validation: { required: "Unit (ZH) is required" },
    },
    {
      fieldName: "Email",
      fieldValue: "field_email_id",
      className: "col-span-6",
      type: "text",
      name: "field_email_id",
      formType: "input",
      label: "Email",
      placeholder: "Enter Email",
      validation: { required: "Email is required" },
    },
    {
        fieldName: "Phone Number",
        fieldValue: "field_phone_number",
        className: "col-span-6",
        type: "text",
        name: "field_phone_number",
        formType: "number",
        label: "Phone Number",
        placeholder: "Enter Phone Number",
        validation: { required: "Phone Number is required" },
    },
    {
        fieldName: "Published",
        fieldValue: "field_contact_profile_published",
        className: "col-span-12",
        type: "checkbox",
        name: "field_contact_profile_published",
        formType: "checkbox",
        label: "Published",
        placeholder: "Enter Published",
        // validation: { required: "Published is required" },
      },
  ],
  CposOffice: [
    {
      fieldName: "Name (EN)",
      fieldValue: "field_cpo_name_en",
      className: "col-span-6",
      type: "text",
      name: "field_cpo_name_en",
      formType: "input",
      label: "Name (EN)",
      placeholder: "Enter Name (EN)",
      validation: { required: "Name (EN) is required" },
    },
    {
        fieldName: "Name (MS)",
        fieldValue: "field_cpo_name_ms",
        className: "col-span-6",
        type: "text",
        name: "field_cpo_name_ms",
        formType: "input",
        label: "Name (MS)",
        placeholder: "Enter Name (MS)",
        // validation: { required: "Name (MS) is required" },
    },
    {
        fieldName: "Name (ZH)",
        fieldValue: "field_cpo_name_zh",
        className: "col-span-6",
        type: "text",
        name: "field_cpo_name_zh",
        formType: "input",
        label: "Name (ZH)",
        placeholder: "Enter Name (ZH)",
        // validation: { required: "Name (ZH) is required" },
    },
    {
        fieldName: "Designation (EN)",
        fieldValue: "field_cpo_designation_en",
        className: "col-span-6",
        type: "text",
        name: "field_cpo_designation_en",
        formType: "input",
        label: "Designation (EN)",
        placeholder: "Enter Designation (EN)",
        validation: { required: "Designation (EN) is required" },
    },
    {
        fieldName: "Designation (MS)",
        fieldValue: "field_cpo_designation_ms",
        className: "col-span-6",
        type: "text",
        name: "field_cpo_designation_ms",
        formType: "input",
        label: "Designation (MS)",
        placeholder: "Enter Designation (MS)",
        // validation: { required: "Designation (MS) is required" },
    },
    {
        fieldName: "Designation (ZH)",
        fieldValue: "field_cpo_designation_zh",
        className: "col-span-6",
        type: "text",
        name: "field_cpo_designation_zh",
        formType: "input",
        label: "Designation (ZH)",
        placeholder: "Enter Designation (ZH)",
        // validation: { required: "Designation (ZH) is required" },
    },
    {
        fieldName: "Department",
        fieldValue: "field_department",
        className: "col-span-6",
        type: "text",
        name: "field_department",
        formType: "input",
        label: "Department",
        placeholder: "Enter Department",
        validation: { required: "Department is required" },
        // loadOptions: fetchDepartment
    },
    {
      fieldName: "Email",
      fieldValue: "field_cpo_email",
      className: "col-span-6",
      type: "text",
      name: "field_cpo_email",
      formType: "input",
      label: "Email",
      placeholder: "Enter Email",
      validation: { required: "Email is required" },
    },
    // {
    //     fieldName: "Phone Number",
    //     fieldValue: "field_cpo_phone_number",
    //     className: "col-span-6",
    //     type: "text",
    //     name: "field_cpo_phone_number",
    //     formType: "number",
    //     label: "Phone Number",
    //     placeholder: "Enter Phone Number",
    //     validation: { required: "Phone Number is required" },
    // },
  ],
  addcontactdirectory: [
    {
      fieldName: "Name (EN)",
      fieldValue: "name",
      className: "col-span-6",
      type: "text",
      name: "name",
      formType: "input",
      label: "Name (EN)",
      placeholder: "Enter Name (EN)",
      validation: { required: "Name (EN) is required" },
    },
    {
        fieldName: "Name (MS)",
        fieldValue: "field_department_name_ms",
        className: "col-span-6",
        type: "text",
        name: "field_department_name_ms",
        formType: "input",
        label: "Name (MS)",
        placeholder: "Enter Name (MS)",
        // validation: { required: "Name (MS) is required" },
    },
    {
        fieldName: "Name (ZH)",
        fieldValue: "field_department_name_zh",
        className: "col-span-6",
        type: "text",
        name: "field_department_name_zh",
        formType: "input",
        label: "Name (ZH)",
        placeholder: "Enter Name (ZH)",
        // validation: { required: "Name (ZH) is required" },
    },
    {
        fieldName: "Published",
        fieldValue: "field_department_published",
        className: "col-span-12",
        type: "checkbox",
        name: "field_department_published",
        formType: "checkbox",
        label: "Published",
        placeholder: "Enter Published",
        // validation: { required: "Published is required" },
      },
  ],
};
